<div class="struct">
  <div class="struct-cont">
    <div class="timeline">
      <div class="line"></div>
      <div class="icon">
        <button (click)="next(1)">
          <i
            class="fa fa-circle"
            style="font-size: large; color: #00c4f4"
            [ngClass]="{ active: currentstate === 1 }"
            aria-hidden="true"
          ></i>
        </button>
        <div class="text-above">16th Aug - 29th Sep</div>
      </div>
      <div class="line"></div>
      <div class="icon">
        <button (click)="next(2)">
          <i
            class="fa fa-circle"
            style="font-size: large; color: #00c4f4"
            [ngClass]="{ active: currentstate === 2 }"
            aria-hidden="true"
          ></i>
        </button>
        <div class="text-below">5th Oct - 4th Nov</div>
      </div>
      <div class="line"></div>
      <div class="icon">
        <button (click)="next(3)">
          <i
            class="fa fa-circle"
            style="font-size: large; color: #00c4f4"
            [ngClass]="{ active: currentstate === 3 }"
            aria-hidden="true"
          ></i>
        </button>
        <div class="text-above">14th Nov - 4th Dec</div>
      </div>
      <div class="line"></div>
      <div class="icon">
        <button (click)="next(4)">
          <i
            class="fa fa-circle"
            style="font-size: large; color: #00c4f4"
            [ngClass]="{ active: currentstate === 4 }"
            aria-hidden="true"
          ></i>
        </button>
        <div class="text-below">E-Summit</div>
      </div>
      <div class="line"></div>
    </div>
    <div class="navigation">
      <div class="navicon">
        <button (click)="navprev()">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
      </div>
      <div class="detail-box">
        <div [@slide]="currentstate" *ngIf="currentstate == 1" class="details">
          <div class="heading">Registration Period</div>
          <div class="date">
            <span>16th Aug - 29th Sep</span>
          </div>
          <div class="para">
            <p>
              Eureka! opens its applications for all entrepreneurs on 16th
              August. Register by filling your details and logging in to the
              Eureka! dashboard. Add your co-founders and fill your startup idea
              details.
            </p>
          </div>
        </div>
        <div [@slide]="currentstate" *ngIf="currentstate == 2" class="details">
          <div class="heading">Zonals Round</div>
          <div class="date">
            <span>5th Oct - 4th Nov</span>
          </div>
          <div class="para">
            <p>
              Get assigned dedicated mentors for exclusive one-on-one sessions.
              Our expert mentors will guide you in developing your business
              model using proven startup methods.
            </p>
          </div>
        </div>
        <div [@slide]="currentstate" *ngIf="currentstate == 3" class="details">
          <div class="heading">Semi-Finals</div>
          <div class="date">
            <span>14th Nov - 4th Dec</span>
          </div>
          <div class="para">
            <p>
              Semi-Finalists are now declared based on the evaluation in the
              zonals. The startups now will receive guidance in building a
              Business Model for their startup.
            </p>
          </div>
        </div>
        <div [@slide]="currentstate" *ngIf="currentstate == 4" class="details">
          <div class="heading">Grand Finale</div>
          <div class="date">
            <span>E-Summit</span>
          </div>
          <div class="para">
            <p>
              Finalists are now declared based on the evaluation in the
              semifinals. The startups now will be invited to IIT Bombay where
              in they will attend Grand Finale of Asia's largest business model
              competition
            </p>
          </div>
        </div>
      </div>
      <div class="navicon">
        <button (click)="navnext()">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
